export default __webpack_public_path__ + "static/media/button-width.1b79b1bb.png";